import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ScoreGraph = ({ game, translations, language }) => {
    const t = translations[language];

    // Generate score history data for the graph
    const generateScoreHistory = () => {
        const data = [];
        let currentScores = game.players.reduce((acc, player) => {
            acc[player.id] = 0;
            return acc;
        }, {});

        // Add initial state (round 0)
        const initialPoint = { round: 0 };
        game.players.forEach(player => {
            initialPoint[player.name] = 0;
        });
        data.push(initialPoint);

        // Process each round
        game.rounds.forEach((round, index) => {
            // Update scores based on round changes
            round.scoreChanges.forEach(change => {
                currentScores[change.playerId] = change.newScore;
            });

            // Create data point for this round
            const point = { round: index + 1 };
            game.players.forEach(player => {
                point[player.name] = Math.round(currentScores[player.id]);
            });
            data.push(point);
        });

        return data;
    };

    const data = generateScoreHistory();

    // Generate colors for each player
    // const playerColors = ['#8884d8', '#82ca9d', '#ffc658', '#ff7c7c', '#8dd1e1', '#d084d0'];
    const playerColors = ['#007311ff', '#080097ff', '#990000ff', '#000000ff'];

    return (
        <div style={{ width: '100%', height: '300px', position: 'relative' }}>
            {/* Custom legend overlay */}
            <div style={{
                position: 'absolute',
                top: '15px',
                left: '100px',
                zIndex: 10,
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                fontSize: '12px'
            }}>
                {game.players.map((player, index) => (
                    <div key={player.id} style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '4px'
                    }}>
                        <div style={{
                            width: '12px',
                            height: '3.3px',
                            backgroundColor: playerColors[index % playerColors.length],
                            marginRight: '8px'
                        }}></div>
                        <span>{player.name}</span>
                    </div>
                ))}
            </div>

            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis
                        dataKey="round"
                        label={{ value: t.rounds || 'Rounds', position: 'insideBottom', offset: -5 }}
                    />
                    <YAxis
                        label={{ value: t.score || 'Score', angle: -90, position: 'insideLeft' }}
                    />
                    <Tooltip
                        labelFormatter={(value) => `${t.round || 'Round'} ${value}`}
                        formatter={(value, name) => [value, name]}
                    />
                    {game.players.map((player, index) => (
                        <Line
                            key={player.id}
                            type="monotone"
                            dataKey={player.name}
                            stroke={playerColors[index % playerColors.length]}
                            strokeWidth={2}
                            dot={{ r: 4 }}
                            activeDot={{ r: 6 }}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ScoreGraph;
